var render = function render(_c,_vm){return _c('div',{staticClass:"user-avatar",class:[_vm.data.class, _vm.data.staticClass, _vm.props.size]},[_c('img',{attrs:{"src":_vm.props.avatar !== '' ? _vm.props.avatar : '/img/avatar.png',"onerror":"this.src='/img/avatar.png'"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }